import { Box, Grid } from "@mui/material";
import styles from "../css/index.module.css";
import { ReactNode } from "react";

interface RightImageAllignedContainerProps {
    children: ReactNode,
    image: any,
    dataTestIdForImage: string
}

export const RightImageAllignedContainer = ({children, image, dataTestIdForImage}: RightImageAllignedContainerProps) => (
    <Grid container spacing={3} className={styles.grid}>
        <Grid item xs={12} md={5}>
            <Box className={styles.platfromInfoContainer}>
                {children}
            </Box>
        </Grid>
        <Grid item xs={12} md={7}>
            <img 
                src={image} 
                alt="About Garuda Desktop Icon" 
                className={styles.screenshot} 
                data-testid={dataTestIdForImage} 
            />
        </Grid>
    </Grid>
)